import { render } from "./registration-account-activation.vue?vue&type=template&id=cebb01a4&scoped=true"
import script from "./registration-account-activation.vue?vue&type=script&lang=js"
export * from "./registration-account-activation.vue?vue&type=script&lang=js"

import "./registration-account-activation.vue?vue&type=style&index=0&id=cebb01a4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cebb01a4"]])

export default __exports__